
     const headers = document.querySelectorAll('.drink-header');

    headers.forEach(header => {
      header.addEventListener('click', () => {
        const item = header.parentElement;
        const icon = header.querySelector('.plus-icon');
        
        // Close others if you want only one open
        document.querySelectorAll('.drink-item').forEach(other => {
          if (other !== item) {
            other.classList.remove('active');
            // other.querySelector('.plus-icon').textContent = '+';
          }
        });

        // Toggle active
        item.classList.toggle('active');
        // icon.textContent = item.classList.contains('active') ? '−' : '+';
      });
    });
  var windowWidth = window.innerWidth;
        const count = document.querySelectorAll('.soda-can').length;

        function animateSodaCan(index) {

            let selector = "#soda-can-" + index;
            let element = document.querySelector(selector);
            let color = element.getAttribute("data-color");
            if (color) {
                // Apply the color as background to .section-1
                document.querySelector(".section-1").style.backgroundColor = color;
                document.querySelector("#shopify-section-sections--19179831591087__header_section").style.backgroundColor = color;
            }

            gsap.to(selector, {
                duration: 2,
                x: "0%",
                y: windowWidth < 767 ? "260px" : "0%",
                ease: "power4.out"
            });
        }

        function animateSodaCanOut(index) {
            gsap.to("#soda-can-" + index, {
                duration: 1,
                x: "0%",
                y: windowWidth < 767 ? "880px" : "800px",
                ease: "power4.out",
                onComplete: function () {
                    resetSodaCan(index);
                }
            });
        }

        function resetSodaCan(index) {
            gsap.to("#soda-can-" + index, {
                duration: 0,
                delay: 0,
                x: "0%",
                y: "-900px",
                ease: "linear"
            });
        }

        document.addEventListener("DOMContentLoaded", function (event) {
            console.log('loaded');
            var current = 1;
            setTimeout(function () {
                animateSodaCan(current);
            }, 1000)
            setInterval(function () {
                var previous = current;
                if (current === count) current = 0;
                animateSodaCanOut(previous); // 1> 1= 2<   2> 2= 3<

                var nextSlide = ++current;
                animateSodaCan(current);
            }, 5000)

        })
             const fadingSlides = document.querySelectorAll(".fading-slides");
            let current = 0;
            const duration = 1;
            gsap.set(fadingSlides[0], {opacity: 1}); // show the first image initially

            setInterval(() => {
                const next = (current + 1) % slides.length;

                gsap.to(fadingSlides[current], {opacity: 0,duration});//{opacity: 0,duration}
                gsap.to(fadingSlides[next], {opacity: 1,duration});//{opacity: 0,duration}

                current = next;
            }, 3 * 1000);

 function createCrossfade(imageIds, pathId, duration = 1, displayTime = 3) {
            const images = imageIds.map(id => document.getElementById(id));
            const svgPath = document.getElementById(pathId);

            // Initial states
            images.forEach((img, i) => {
                gsap.set(img, {opacity: i === 0 ? 1 : 0});
            });
            svgPath.setAttribute("fill", images[0].dataset.bg);

            const tl = gsap.timeline({repeat: -1});

            images.forEach((img, i) => {
                const nextImg = images[(i + 1) % images.length];

                // Fade out current, fade in next
                tl.to(img, {
                    opacity: 0,
                    duration: duration,
                    onStart: () => {
                        svgPath.setAttribute("fill", nextImg.dataset.bg);
                    }
                }, "+=" + displayTime);

                tl.to(nextImg, {
                    opacity: 1,
                    duration: duration
                }, "<");
            });
        }

        // Example usage:
        document.addEventListener("DOMContentLoaded", () => {
            createCrossfade(["image1", "image2","image3","image4"], "monkey-bg-path", 1, 3);
            createCrossfade(["mb1", "mb2","mb3","mb4"], "monkey-bg-path2", 1, 3);
        });           

 gsap.registerPlugin(ScrollTrigger);

            // First Line (Left to Right)
            gsap.to("#movingText1", {
                scrollTrigger: {
                    trigger: ".scroll-container",
                    start: "top 80%",
                    end: "bottom top",
                    scrub: 1, // Smooth scrolling effect
                },
                attr: {startOffset: "100%"}, // Moves text across the wave path
                opacity: 1, // Fades in
                ease: "linear"
            });

            // Second Line (Right to Left, Stays Upright)
            gsap.to("#movingText2", {
                scrollTrigger: {
                    trigger: ".scroll-container",
                    start: "top 90%",
                    end: "bottom top",
                    scrub: 1, // Smooth scrolling effect
                },
                attr: {startOffset: "0%"}, // Moves text from right to left naturally
                opacity: 1, // Fades in
                ease: "linear"
            });

new Splide('.xs-testimonial-section .splide', {
                perPage: 1,
                gap: '1rem',
                mediaQuery: 'min',
                pagination: false,
                padding: {
                    right: '4rem',
                    left: '2rem'
                },
                arrows: false,
                breakpoints: {
                    640: {
                        perPage: 2,
                        padding: {
                            left: '0',
                            right: '8rem'
                        },
                        gap: '2rem',
                    },
                    1024: {
                        padding: '10rem',
                        perPage: 2,
                    }, 1500: {
                        padding: '10rem',
                        perPage: 3,
                    },

                },
            }).mount();


// slider

function fitTextToContainer(el) {
        const container = el.parentElement;
        el.style.fontSize = '10px'; // Reset to a base size
        let scale = container.clientWidth / el.scrollWidth;
        el.style.transform = `scale(${scale})`;
    }

    var ss1 = new Splide('.x-splide', {
        focus: 'center',
        width: '100%',
        perPage: 1,
        pagination: true,
        speed: 1200,
        perMove: 1,
        mediaQuery: 'min',
        arrows: false,
        padding: {
            left: '28%',
            right: '28%',
        },

    })
    var lastIndex = -1;
    ss1.on('move', (newIndex) => {
        if (newIndex !== lastIndex) {
            lastIndex = newIndex;

            document.querySelectorAll('.pinfo-1,.pinfo-2,.pinfo-3,.pinfo-4').forEach(img => {
                img.classList.add('hidden');
            });
            document.querySelectorAll('.pinfo-' + (newIndex + 1)).forEach(img => {
                img.classList.remove('hidden');
            });

            // Animations
            document.querySelectorAll('.bg-img1,.t1,.t2,.headline1').forEach(img => {
                void img.offsetWidth;
                img.classList.remove('fade-in');
            });
            document.querySelectorAll('.can-img').forEach(img => {
                img.classList.add('scale-down');
            });

            const slide = ss1.Components.Slides.getAt(newIndex)?.slide;

            // Change background (by color or class)
            if (slide) {
                const bgColor = slide.dataset.bg;
                if (bgColor) {
                    document.querySelector('.x-splide').style.backgroundColor = bgColor;
                    document.querySelector('.product-info').style.backgroundColor = bgColor;
                }

                // Optional: if using class-based background
                // const bgClass = slide.dataset.bgClass;
                // const section = document.querySelector('.x-splide');
                // section.className = 'x-splide splide w-full min-h-screen ' + bgClass;

                setTimeout(function () {
                    slide.querySelectorAll('.bg-img1,.t1,.t2,.headline1').forEach(img => {
                        void img.offsetWidth;
                        img.classList.add('fade-in');
                        img.classList.remove('scale-down');
                    });
                }, 500);

                slide.querySelectorAll('.can-img').forEach(img => {
                    img.classList.remove('scale-down');
                });
            }
        }
    });


    ss1.on('mounted', () => {
        const slide = ss1.Components.Slides.getAt(ss1.index)?.slide;
        if (slide) {
            slide.querySelectorAll('.bg-img1, .t1, .t2,.headline1').forEach(el => {
                el.classList.add('fade-in');
            });
            slide.querySelectorAll('.can-img').forEach(el => {
                console.log(el);
                el.classList.remove('scale-down');
            });

            // Set initial background
            const bgColor = slide.dataset.bg;
            if (bgColor) {
                document.querySelector('.x-splide').style.backgroundColor = bgColor;
                document.querySelector('.product-info').style.backgroundColor = bgColor;
            }
        }
    });

    ss1.mount();
    const slides = document.querySelectorAll('.x-splide .splide__slide');

    slides.forEach((slide, index) => {
        slide.addEventListener('click', () => {
            ss1.go(index);
        });
    });


const variantBtns = document.querySelectorAll(".graps");
const priceBox = document.querySelector(".price");
const hiddenInput = document.querySelector("input[name='id']");
const discountedPricemg = document.querySelector(".discounted-price");
const originalPricemg = document.querySelector(".original-price");
variantBtns.forEach(btn => {
  btn.addEventListener("click", () => {
    // remove active from all
    variantBtns.forEach(b => b.classList.remove("active"));
    // add active on selected
    btn.classList.add("active");
    // update price
     discountedPricemg.textContent = `₹${btn.dataset.price}.00`;
    // update original price
    originalPricemg.textContent = `₹${btn.dataset.original}.00`;
    // update hidden variant ID
    hiddenInput.value = btn.dataset.id;
  });
});

 // for mango
const mangop = document.querySelectorAll(".mangop");
const mangoprice = document.querySelector(".mangoprice");
const hiddenInputm = document.querySelector("#mango input[name='id']");
const discountedPricem = document.querySelector(".dp");
const originalPricem = document.querySelector(".op");
mangop.forEach(btn => {
  btn.addEventListener("click", () => {

    mangop.forEach(b => b.classList.remove("active"));
    btn.classList.add("active");
    discountedPricem.textContent = `₹${btn.dataset.pricem}.00`;
    // update original price
    originalPricem.textContent = `₹${btn.dataset.originalm}.00`;
     //mangoprice.textContent = `₹${btn.dataset.price}.00`;

    hiddenInputm.value = btn.dataset.id;
  });
});

 // for lemon
const lemonp = document.querySelectorAll(".lemonp");
const lemonprice = document.querySelector(".lemonprice");
const hiddenInputl = document.querySelector("#lemon input[name='id']");
const discountedPrice = document.querySelector(".gdp");
const originalPrice = document.querySelector(".gop");
lemonp.forEach(btn => {
  btn.addEventListener("click", () => {

    lemonp.forEach(b => b.classList.remove("active"));
    btn.classList.add("active");
    discountedPrice.textContent = `₹${btn.dataset.priceg}.00`;
    // update original price
    originalPrice.textContent = `₹${btn.dataset.originalg}.00`;
    //lemonprice.textContent = `₹${btn.dataset.price}.00`;
    hiddenInputl.value = btn.dataset.id;   // <-- FIXED
  });
});
 // for apple
const applep = document.querySelectorAll(".applep");
const appleprice = document.querySelector(".appleprice");
const hiddenInputa = document.querySelector("#apple input[name='id']");
const discountedPricea = document.querySelector(".gda");
const originalPricea = document.querySelector(".goa");
applep.forEach(btn => {
  btn.addEventListener("click", () => {

    applep.forEach(b => b.classList.remove("active"));
    btn.classList.add("active");
    discountedPricea.textContent = `₹${btn.dataset.pricea}.00`;
    // update original price
    originalPricea.textContent = `₹${btn.dataset.originala}.00`;
    //applep.textContent = `₹${btn.dataset.price}.00`;
    hiddenInputa.value = btn.dataset.id;   // <-- FIXED
  });
});

    // const titles = document.querySelectorAll(".xs-accordion .title");

    // titles.forEach(title => {
    //   title.addEventListener("click", () => {
    //     const item = title.parentElement;
    //     item.classList.toggle("active");
    //   });
    // });

document.querySelectorAll(".item .title").forEach(title => {
  title.addEventListener("click", () => {
    const item = title.parentElement;
    const icon = title.querySelector("i");

    // toggle accordion
    item.classList.toggle("active");

    // change icon
    if (item.classList.contains("active")) {
      icon.classList.remove("fa-chevron-down");
      icon.classList.add("fa-chevron-up");
    } else {
      icon.classList.remove("fa-chevron-up");
      icon.classList.add("fa-chevron-down");
    }
  });
});


    // gsap.fromTo(".sc-text",
    //     {xPercent: -100},  // start off-screen to the left
    //     {
    //         xPercent: 0,       // move it to original position
    //         repeat: -1,
    //         ease: "none",
    //         duration: 10
    //     }
    // );
gsap.to(".text-wrap", {
  xPercent: -100,
  repeat: -1,
  duration: 70,
  ease: "none",
  modifiers: {
    xPercent: gsap.utils.wrap(-100, 0) // smooth infinite loop
  }
});



  const closeBtns = document.querySelector('.header__drawer--mobile');
  const mainContents = document.querySelector('main#MainContent');
  closeBtns.addEventListener('click', () => {
    mainContents.classList.toggle('blurred');
  });

